import React from 'react';
import styled, { keyframes } from 'styled-components';

import Box from './Box';
import Flex from './Flex';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Base = styled(Box)`
  animation: ${fadeIn} 1s;
`;

const CloseIcon = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 1.5rem;
  margin-left: 1rem;
`;

export default ({ content, removeAlert }) => {
  return (
    <Base
      bg="grayscale.black"
      color="grayscale.white"
      borderRadius={['0', '4px']}
      p={3}
      mb={[0, 4]}
      ml={[0, 3]}
      data-testid="toast-alert"
    >
      <Flex alignItems="center" justifyContent="space-between">
        {content}
        <CloseIcon onClick={removeAlert}>&times;</CloseIcon>
      </Flex>
    </Base>
  );
};
